import React from 'react';
import { Link } from 'react-router-dom'
import TextField from 'material-ui/TextField';
import {Row,Col} from 'react-bootstrap';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Route, Redirect} from 'react-router-dom'
import CircularProgress from 'material-ui/CircularProgress';
//stripe payment
import {StripeProvider} from 'react-stripe-elements';
import {Elements} from 'react-stripe-elements';
import InjectedCheckoutForm from './PaymentForm';
import { connect } from 'react-redux';
import {handlePlan,cancelPopUp,submitCompanyData,submitContactOther,submitContactNone,fetchSubscription,validateCompanyData,cancelValidation} from '../../../Actions/signup'; 
import 'whatwg-fetch';
import ValidateEmail from '../LoginSignup/ValidateEmail';
import env from '../../../config/env.js'
const stripePublishableKey=env.stripePublishableKey;

class Home extends React.Component{
    constructor(props){
        super(props);
        this.InformationToggle = this.InformationToggle.bind(this);
        this.state={
            information: 'deactivate-information',
            companyNameReq: false,
            companyWebsiteReq: false,
            userNameReq: false,
            userEmailReq: false,
            userPasswordReq: false,
            passMatch: false,
            contactCompany: '',
            contactEmail: '',
            contactCompanyNone: '',
            contactEmailNone: '',
            contactTel: false,
            passValidationText: '',
            validation: false,
            onceSubmit: false,
            buttonDisable: false,
            stepComplete: true,
            modalIsOpen: true,
            companyNameEdit: false,
            companyName1: '',
            userNameEdit: '',
            userEmailEdit: '',
            companyReadOnly: false,
            userNameReadOnly: false,
            userEmailReadOnly: false
        };
        this.handlePlans= this.handlePlans.bind(this);
        this.handleClose= this.handleClose.bind(this);
        this.submitCompanyForm= this.submitCompanyForm.bind(this);
        this.submitContactNone= this.submitContactNone.bind(this);
        this.submitContactOther= this.submitContactOther.bind(this);
        this.onInputChange=this.onInputChange.bind(this);
        this.validateInputs=this.validateInputs.bind(this);
        this.submitValidateCompanyData=this.submitValidateCompanyData.bind(this);
       
        this.mapFieldToError={
            email:'userEmailReq',
            name: 'companyNameReq'
        }
    }


    componentWillReceiveProps(nextProps)
    {   
        let checkButtonstatus=nextProps.signUp.disableButtonStatus;
        this.setState({buttonDisable:checkButtonstatus});
        const validateCompanyError=nextProps.signUp.validateCompanyErrors;
        for(var index in validateCompanyError){
            const errorState=this.state[this.mapFieldToError[index]];
            if(this.state[this.mapFieldToError[index]])
            continue;
            if(typeof errorState!=='undefined'){
                const errorIndex=this.mapFieldToError[index];
                this.setState({
                    [errorIndex]:validateCompanyError[index].msg
                });
            }
        }

    }
  
    // fetch selected plan detail
    componentDidMount(){
        let queryParams=new URLSearchParams(this.props.location.search);
        var plan=queryParams.get('plan');
        if(plan){
            this.props.fetchSubscriptionRequest(plan);
        }
        let check_stepComplete = this.props.signUp.signupUser ? this.props.signUp.signupUser.company.step_completed : '';
        if(check_stepComplete === 1){
            setTimeout(()=>{
                var elem = document.getElementById('leftpage');
                elem.scrollTop=elem.scrollHeight;
            }, 1000)
        }
        
        
    }

    handlePlans(event){
        this.props.setPlans(event.target.value);
    }

    handleClose(){
        this.props.cancelPopUp(false);
    }

    InformationToggle(){
     let value =  (this.state.information === 'deactivate-information') ? 'active-information' : 'deactivate-information' 
        this.setState({ information : value });
    }
    // submit contact none popup
    submitContactNone(e){

        var name= document.contactNone.company_name.value;
        var email= document.contactNone.email.value;

        var validation='true';
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(name===''){
            this.setState({contactCompanyNone:'please enter your name.'});
            validation='false';
            return false;
        }else{
            this.setState({contactCompanyNone:''});
        }
        if(email===''){
            this.setState({contactEmailNone:'Please enter your email.'});
            validation='false';
            return false;
        }else{
            this.setState({contactEmailNone:''});
        }

       if(email!=''){
            if(!re.test(email)){
                this.setState({contactEmailNone:'Please input a valid email.'});
                return false;
            }else{
                this.setState({contactEmailNone:''});
            }
        }
        if(validation==='true'){
            this.props.submitContactNoneForm(name,email);
        }
    }

    //submit contact other popup
    submitContactOther(e){
        var name= document.contactOther.company_name.value;
        var email= document.contactOther.email.value;
        var telephone='';
        var validation='true';
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(name===''){
            this.setState({contactCompany:'please enter your name'});
            validation='false';
            return false;
        }else{
            this.setState({contactCompany:''});
        }
        if(email===''){
            this.setState({contactEmail:'Please enter your email.'});
            validation='false';
            return false;
        }else{
            this.setState({contactEmail:''});
        }
        if(email!=''){
            if(!re.test(email)){
                this.setState({contactEmail:'Please input a valid email.'});
                return false;
            }else{
                this.setState({contactEmail:''});
            }
        }
        if(validation==='true'){
            this.props.submitContactOtherForm(name,email,telephone);
        }
    }
    // form validation
    validateInputs()
    {
        var name= document.companyForm.company_name.value;
        var email= document.companyForm.email.value;
        var password= document.companyForm.password.value;
        var verify_pass= document.companyForm.verify_pass.value;
        //var selected_pms= document.companyForm.shipSpeed.value;
        var user_name= document.companyForm.user_name.value;
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var regxName = /^[a-zA-Z ]{1,40}$/;
        var validation=true;
        var alphanumericSpace=/^[\w\s]+$/;

        if(name===''){
            this.setState({companyNameReq:'Company name is required.'});
            validation=false;
        }else if(!name.match(regxName)){
            this.setState({companyNameReq:'Company name should not contain numbers or special characters.'});
            validation=false;
        }else{
            this.setState({companyNameReq:false});
        }        

        if(user_name===''){
            this.setState({userNameReq:'User name is required.'});
            validation=false;
        }else if(!user_name.match(regxName)){
            this.setState({userNameReq:'User Name should not contain numbers or special characters.'});
            validation=false;
        }else{
            this.setState({userNameReq:false});
        }

        if(email===''){
            this.setState({userEmailReq:'User email is invalid.'});
            validation=false;
        }else if(!re.test(email)){
            this.setState({userEmailReq:'Please input a valid email.'});
            validation=false;
        }
        else{
            this.setState({userEmailReq:false});
        }

        // var Alphanumeriregex = /((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+[0-9a-z]{6,}$/i;
        var Alphanumeriregex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/i;
        if(password===''){
            this.setState({userPasswordReq:'Password is required.'});
            validation=false;
        }
        else if(!password.match(Alphanumeriregex))
        {   
            this.setState({userPasswordReq:'Password should be alphanumeric and should contain a minimum of 6 character.'});
            validation=false;
        }else{
            this.setState({userPasswordReq:false});
        }

        if(verify_pass===''){
            this.setState({passMatch:'Confirmation password is required.'});
            validation=false;
        }else{
            this.setState({passMatch:false});
        }
        
        if(verify_pass!==password){
            this.setState({passMatch:"Password not matched."});
            validation=false;
        }else{
            this.setState({passMatch:false});
        }

        this.setState({validation:validation});
        return validation;
    }
    submitValidateCompanyData(e)
    {
        e.preventDefault();
        this.setState({onceSubmit:true});
        let validation=this.validateInputs();
        if(validation){
            var name= document.companyForm.company_name.value;
            var email= document.companyForm.email.value;
            var password= document.companyForm.password.value;
            var selected_pms= document.companyForm.shipSpeed.value;
            var user_name= document.companyForm.user_name.value;
            var plan=0;
            plan=this.props.signUp.subscriptions?this.props.signUp.subscriptions._id:'';
            this.setState({buttonDisable:true});
            this.props.validateCompanyData(name,email,password,selected_pms,user_name,plan);
        }
    }

    submitCompanyForm(otp){
        if(this.state.validation){
            let queryParams=new URLSearchParams(this.props.location.search);
            var plan_number=queryParams.get('plan');
            
            var name= document.companyForm.company_name.value;
            var email= document.companyForm.email.value;
            var password= document.companyForm.password.value;
            var selected_pms= document.companyForm.shipSpeed.value;
            var user_name= document.companyForm.user_name.value;
            var plan=0;
            plan=this.props.signUp.subscriptions?this.props.signUp.subscriptions._id:'';
            this.setState({buttonDisable:true});
            this.props.submitCompanyFormData(name,email,password,selected_pms,user_name,plan,otp, plan_number)
        }
        this.setState({
            userEmailReq:false,
            companyWebsiteReq:false
        });
    }

    onInputChange(event)
    {   
        var user_name= document.companyForm.user_name.value;
        var EmailEdit= document.companyForm.email.value;
        var name1= document.companyForm.company_name.value;
        this.setState({companyNameEdit: true, 
            companyName1: name1, 
            userNameEdit: user_name,
            userEmailEdit: EmailEdit
         })
        if(this.state.onceSubmit)
        {
            this.validateInputs();
        }
    }
    stepOneCompleted = () =>{
        // console.log('signup', this.props.signUp);
        this.setState({modalIsOpen: false});
    }
    render(){
        // console.log('this.props.notification', this.props.notification);
        // console.log('step completed', this.props.signUp);
        let companyName = this.props.signUp.signupUser ? this.props.signUp.signupUser.company.name : '';
        let userName = this.props.signUp.signupUser ? this.props.signUp.signupUser.user.name : '';
        let userEmail = this.props.signUp.signupUser ? this.props.signUp.signupUser.user.email : '';
        let check_stepComplete = this.props.signUp.signupUser ? this.props.signUp.signupUser.company.step_completed : '';
        // console.log('check step completed', check_stepComplete);
        
        const actionsOther = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleClose}
          />,
          <RaisedButton
            label="Submit"
            primary={true}
             labelStyle={{'color': '#fff'}}
            keyboardFocused={true}
            onClick={this.submitContactOther}
          />,
        ];
        const actionsNone = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleClose}
          />,
          <RaisedButton
            label="Submit"
            primary={true}
            labelStyle={{'color': '#fff'}}
            keyboardFocused={true}
            onClick={this.submitContactNone}
          />,
        ];
        const action1 = [
          <RaisedButton
            label="OK"
            primary={true}
            labelStyle={{'color': '#fff'}}
            keyboardFocused={true}
            onClick={()=>this.stepOneCompleted()}
          />,
        ];
        let subscription='',amountToBePaid=0,subscriptionType=0,customerEmail='',customerName='';
        let customerUserId = '', customerCompanyId = '';
        
        if(this.props.signUp.subscriptions){
           const listFeatures=this.props.signUp.subscriptions.description.map((desc,index)=>{
                return (
                    <li key={index}>
                        <Link to="#">
                            {desc} <i className="fa fa-check-circle"></i>
                        </Link>
                    </li>
                );
            });

            subscription=(
                <div>
                    <h4>{this.props.signUp.subscriptions.title}</h4>
                    <div className="featured-list">
                        <ul>
                            {listFeatures}
                        </ul>
                        <h4>Feature Tip:</h4>
                        <p>{this.props.signUp.subscriptions.feature_tip} </p>
                    </div>
                </div>
            );
           
            var base_price=this.props.signUp.subscriptions.price;
            amountToBePaid=base_price;
            this.props.signUp.subscriptions.taxes.forEach(tax => {
                amountToBePaid+=((base_price/100)*(tax.percentage));
            });
            var taxApplied = 0;
            this.props.signUp.subscriptions.taxes.forEach(tax => {
                taxApplied += parseFloat(base_price * tax.percentage / 100);
            });
            var total_amout_inc_vat= 0;
            total_amout_inc_vat=(base_price+taxApplied).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); //converted to thousand place
            subscriptionType=parseInt(this.props.signUp.subscriptions.type);
        }


        if(this.props.signUp.signupUser){
            customerEmail=this.props.signUp.signupUser.user.email;
            customerName=this.props.signUp.signupUser.user.name;
            customerUserId=this.props.signUp.signupUser.user._id;
            customerCompanyId=this.props.signUp.signupUser.company._id;
        }

        const  validateOtpModal=<ValidateEmail open={(this.props.signUp.validatedCompany)&&(this.props.signUp.setStep===1)} verifyOtp={this.submitCompanyForm}  cancelClick={this.props.cancelValidation}/>
        
	  	return(
            
            <div>   
                {validateOtpModal}
            {this.props.signUp.contact===true?<Route exact path="/signup" render={() => ( <Redirect to="/thankyou" /> )} />:""}
                    <div className="signup-page" >
                        <div id="leftpage" className="signup-left col-6" >
                            <div className="show-information vissible-sm vissible-xs"  onClick={this.InformationToggle}>
                                <i className="zmdi zmdi-info"></i>
                            </div>
                            <div className="signup-form-section">
                                <div className="logo-dokkit">
                                    <figure>
                                        <Link to="#">
                                            <img src="/images/dokkit-logo.png" alt="logo" />
                                        </Link>
                                    </figure>
                                </div>
                                 <form name="companyForm" onSubmit = {this.submitValidateCompanyData}>
                                    <h5>Welcome to Dokkit!</h5>
                                    { this.props.signUp.subscriptions && 
                                        <h3>Sign up to the {this.props.signUp.subscriptions.title}</h3>
                                    }
                                    { this.props.signUp.signupUser && this.props.signUp.signupUser.company.step_completed === 1 ?
                                        <Dialog 
                                            actions={action1}
                                            className="model-support"
                                            modal={false}
                                            contentClassName="model-top-overlay no-overlay"
                                            open={ this.state.modalIsOpen}
                                            onRequestClose={this.closeModal}
                                        >
                                              <p>
                                                  Please complete the payment information, you won't be charged today, and follow the next steps to complete the signup
                                              </p>                  
                                        </Dialog>
                                        : null
                                    }
                                    <Row>
                                        <Col md={12}>
                                             <TextField
                                                hintText="Enter your company name"
                                                fullWidth={ true }
                                                disabled={check_stepComplete === 1? true: false}
                                                floatingLabelText="What's your company's name?"
                                                floatingLabelFixed={true}
                                                name='company_name'
                                                value={!this.state.companyNameEdit ? companyName: this.state.companyName1}
                                                errorText={ this.state.companyNameReq }
                                                onChange={this.onInputChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                     <Col md={12}>
                                         <h3>Current project management software</h3>
                                     </Col>
                                    </Row>
                                    <Row>
                                       <Col md={12}  className="margb15px">
                                            <RadioButtonGroup name="shipSpeed" defaultSelected={ this.props.signUp.setPlan==='simpro' ? 'simpro' : false}>
                                                    <RadioButton
                                                         value="simpro"
                                                        label="SimPRO"
                                                        disabled={check_stepComplete === 1? true: false}
                                                        name='type_pms'
                                                        onClick={this.handlePlans}
                                                        style={{'marginBottom':10}}
                                                    />
                                                    <RadioButton
                                                        onClick={this.handlePlans}
                                                        value="other"
                                                        disabled={check_stepComplete === 1? true: false}
                                                        label="Other"
                                                        name='type_pms'
                                                        style={{'marginBottom':10}}
                                                    />
                                                    <RadioButton
                                                     onClick={this.handlePlans}
                                                        value="none"
                                                        label="None"
                                                        disabled={check_stepComplete === 1? true: false}
                                                        name='type_pms'
                                                        style={{'marginBottom':10}}
                                                    />
                                            </RadioButtonGroup>
                                       </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <TextField
                                                hintText="Enter your name"
                                                fullWidth={ true }
                                                disabled={check_stepComplete === 1? true: false}
                                                floatingLabelText="User name"
                                                name='user_name'
                                                value={!this.state.companyNameEdit ? userName: this.state.userNameEdit}
                                                errorText={ this.state.userNameReq }
                                                onChange={this.onInputChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <TextField
                                                hintText="Enter Email Id"
                                                fullWidth={ true }
                                                disabled={check_stepComplete === 1? true: false}
                                                floatingLabelText="User email"
                                                type="email"
                                                name='email'
                                                value={!this.state.companyNameEdit ? userEmail: this.state.userEmailEdit}
                                                errorText={ this.state.userEmailReq }
                                                onChange={this.onInputChange}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <TextField
                                                hintText="Enter Password"
                                                fullWidth={ true }
                                                disabled={check_stepComplete === 1? true: false}
                                                floatingLabelText="Password *"
                                                type="password"
                                                name='password'
                                                errorText={ this.state.userPasswordReq }
                                                onChange={this.onInputChange}                                                
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12} className="margb25px">
                                            <TextField
                                                hintText="Re-enter Password"
                                                fullWidth={ true }
                                                disabled={check_stepComplete === 1? true: false}
                                                floatingLabelText="Confirm Password *"
                                                type="password"
                                                name='verify_pass'
                                                errorText={ this.state.passMatch }
                                                onChange={this.onInputChange}
                                            />
                                              {/* required={ this.state.passMatch } */}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}  className="margb20px">
                                           <RaisedButton 
                                           disabled={this.props.signUp.setStep===1 && this.props.signUp.setPlan==='simpro' && !this.state.buttonDisable?false:true} 
                                           label={ !this.state.stepComplete && this.state.buttonDisable ? 
                                               <CircularProgress size={32} color="#fff"/> : "Submit" } 
                                           type="submit" 
                                           labelColor="#fff" 
                                           fullWidth={true}
                                           />
                                        </Col>

                                    </Row>
                                </form>
                                <Row>
                                    <Col md={12} className="margb15px">
                                       <h3 className="right-line">
                                           <span className="bg-white">Purchase Summary</span>
                                       </h3>
                                       <div className="plan-summary-home business-starter">
                                            <table className="plan-pice-table">
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <h3 className="text">
                                                               <span className="blue-color">Dokkit {this.props.signUp.subscriptions && this.props.signUp.subscriptions.label}</span>
                                                           </h3>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                             <table width="100%" className="plan-pice-table">
                                                <tbody> 
                                                    <tr>
                                                        <td>
                                                            <h5>
                                                                <span className="green-color">Today’s charge: £0.00</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                <tr>
                                                    <td>
                                                        <h6>After 14 days: &pound;{this.props.signUp.subscriptions && total_amout_inc_vat } per {this.props.signUp.subscriptions && this.props.signUp.subscriptions.duration_type==='MONTHLY'?'month':'year'} inc. VAT</h6>
                                                    </td>    
                                                </tr>
                                                </tbody>
                                             </table>
                                       </div>
                                       <hr/>
                                       <div className="plan-summary-home">
                                             <table width="100%" className="plan-pice-table">
                                                <tbody> 
                                                    <tr>
                                                        <td>
                                                            <h5>
                                                                <span className="green-color">Enter your payment info</span>
                                                            </h5>
                                                        </td>
                                                    </tr>
                                                <tr>
                                                    <td>
                                                        <h6>Free for 14 days. Cancel anytime.<a href="https://www.dokkit.co.uk/pricing" target="_blank"> Learn more.</a></h6>
                                                    </td>
                                                </tr>
                                                </tbody>
                                             </table>
                                       </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <StripeProvider apiKey={stripePublishableKey}>
                                          <Elements>
                                            <InjectedCheckoutForm 
                                                {...this.props}
                                                amountToBePaid={amountToBePaid} 
                                                subscriptionType={subscriptionType} 
                                                customerEmail={customerEmail}
                                                customerName={customerName}
                                                customerUserId={customerUserId}
                                                customerCompanyId={customerCompanyId}
                                             />
                                          </Elements>
                                        </StripeProvider>
                                    </Col>
                                </Row>
                                        
                            </div>
                            <div className="tab-navigation">
                                <ul>
                                    <li className="active" >
                                        <Link to="#">
                                            <span>1</span> Company Setup
                                        </Link>
                                    </li> 
                                     <li>
                                        <Link to={"#"}>
                                            <span>2</span> O&M Setup
                                        </Link>
                                    </li>
                                     <li>
                                        <Link to={"#"}>
                                            <span>3</span> Integration information
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        
                        <div className={`signup-right col-6 display-flex ${this.state.information}`}>
                            <div className="right-content margin-auto">
                                <h3>Hey there!</h3>
                                <p>Let's get you up and running on Dokkit!</p>
                                <figure>
                                    <img src="/images/vector.png" alt="vector" />
                                </figure>
                                {subscription}
                            </div>
                        </div>

                        <Dialog
                          actions={actionsOther}
                          className="model-other"
                          modal={false}
                          contentClassName="model-top-overlay"
                          open={ this.props.signUp.setPlan==='other' ? this.props.signUp.openPopup : false }
                          onRequestClose={this.handleClose}
                        >       
                            <div className="other-popup-content">
                                <h3>Dokkit is currently only available for use with a workflow management system.</h3>
                                 <p>To discuss a solution please give us your details and we will get back to you.</p>
                                  <div className="popup-data">
                                    <form name="contactOther">
                                        <Row>
                                            <Col md={12}>
                                                <TextField
                                                    hintText="Enter your name"
                                                    fullWidth={ true }
                                                    floatingLabelText="Your Name"
                                                    type="text"
                                                    name="company_name"
                                                    errorText={ this.state.contactCompany }
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <TextField
                                                    hintText="Enter email address"
                                                    fullWidth={ true }
                                                    floatingLabelText="Email address"
                                                    type="email"
                                                    name="email"
                                                    errorText={ this.state.contactEmail }
                                                />
                                            </Col>
                                        </Row>
                                    </form>
                                </div>
                            </div>
                        </Dialog>

                        <Dialog
                          actions={actionsNone}
                          className="model-other"
                          modal={false}
                          contentClassName="model-top-overlay"
                          open={ this.props.signUp.setPlan==='none' ? this.props.signUp.openPopup : false }
                          onRequestClose={this.handleClose}
                        >       
                            <div className="other-popup-content">
                                <h3>Dokkit is currently only available for use with a workflow management system.</h3>
                                 <p>To discuss a solution please give us your details and we will get back to you.</p>
                                  <div className="popup-data">
                                    <form name="contactNone">
                                        <Row>
                                            <Col md={12}>
                                                <TextField
                                                    hintText="Enter your name"
                                                    fullWidth={ true }
                                                    floatingLabelText="Your Name"
                                                    type="text"
                                                    name="company_name"
                                                    errorText={ this.state.contactCompanyNone }
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <TextField
                                                    hintText="Enter email address"
                                                    fullWidth={ true }
                                                    floatingLabelText="Email address"
                                                    type="email"
                                                    name="email"
                                                    errorText={ this.state.contactEmailNone }
                                                />
                                            </Col>
                                        </Row>
                                    </form>
                                </div>
                            </div>
                        </Dialog>

                    </div>
                </div>		
		  )
    }
}

const mapStateToProps= (state,props)=> {

    return {
      signUp : state.signup,
      notification: state.notifications
    };
}

const mapActionToProps={
    setPlans : handlePlan,
    cancelPopUp : cancelPopUp,
    submitCompanyFormData : submitCompanyData,
    validateCompanyData: validateCompanyData,
    submitContactOtherForm : submitContactOther,
    submitContactNoneForm : submitContactNone,
    fetchSubscriptionRequest:fetchSubscription,
    cancelValidation: cancelValidation,
};

export default connect(mapStateToProps,mapActionToProps)(Home);



// WEBPACK FOOTER //
// ./src/Components/Modules/LoginSignup/Home.js